<div class="flex h-screen overflow-hidden">

  <!-- ── Mobile backdrop — only rendered when drawer is open ── -->
  @if (drawerOpen()) {
    <div
      class="sidebar-mobile-backdrop"
      (click)="drawerOpen.set(false)"
    ></div>
  }

  <!-- ── Sidebar wrapper ──
       CSS handles positioning: static on desktop, fixed drawer on mobile.
       .drawer-open slides it in via CSS transform.
  ── -->
  <div
    class="sidebar-drawer-wrapper"
    [class.drawer-open]="drawerOpen()"
  >
    <app-sidebar
      [isMobile]="isMobile()"
      [collapsed]="sidebarCollapsed()"
      (closeDrawer)="drawerOpen.set(false)"
      (toggleCollapse)="toggleSidebarCollapse()"
    />
  </div>

  <!-- ── Main content area (fills full width on mobile since sidebar is out of flow) ── -->
  <div class="flex flex-col flex-1 min-w-0 overflow-hidden">
    <app-tab-bar
      (toggleDrawer)="drawerOpen.set(!drawerOpen())"
    />
    <main class="flex-1 overflow-y-auto overflow-x-hidden app-page-bg">
      <router-outlet />
    </main>
  </div>

</div>
